/* Saundarya — formateador de moneda compartido.

   Respeta el money_format de la tienda en vez de asumir un formato, y replica
   `money_without_trailing_zeros`, que es el filtro que usan todas las piezas
   Saundarya en el render inicial. Sin esto, un importe recalculado por JS
   cambiaria de forma respecto al que pinto Liquid ($10.900 -> $10.900,00).

   Vive en un asset propio porque lo usan la barra de envio de la cabecera, la
   ficha de producto y el modulo de rutina; tenerlo tres veces en linea era
   garantizar que las tres versiones se separaran con el tiempo. */
window.saundaryaMoney = function (cents, format) {
  const value = cents / 100;
  const plantilla = format || '${{amount}}';
  return plantilla.replace(/\{\{\s*(\w+)\s*\}\}/, (_, nombre) => {
    const decimales = nombre.includes('no_decimals') ? 0 : 2;
    const conComa = nombre.includes('comma_separator');
    const partes = value.toFixed(decimales).split('.');
    const miles = conComa ? '.' : ',';
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
    if (partes.length === 1 || Number(partes[1]) === 0) return partes[0];
    return partes.join(conComa ? ',' : '.');
  });
};
